import { PropsWithChildren } from 'react'
import Styles from './Loading.module.scss'

import { Heading } from 'blaze-ui/Heading/Heading'
import cx from 'classnames'

type Progress = {
  title: string
  isRunning: boolean
  percentComplete: number
}

interface Props {
  progresses: Progress[]
  header?: string
}

export const Loading = ({ progresses, children, header }: PropsWithChildren<Props>) => {
  return (
    <div className={Styles.processingContainer} data-testid="processing-container">
      <div className={Styles.processingContent}>
        {children}
        <div className={Styles.textAndControls}>
          <div className={Styles.loadingTextContainer}>
            <div className={Styles.headerAndDescription}>{header && <Heading level={5}>{header}</Heading>}</div>
            <div className={Styles.headingsContainer}>
              {progresses.map((progress) => {
                const isRunning = progress.isRunning || progress.percentComplete >= 99

                return (
                  <div
                    className={cx(Styles.progressHeading, {
                      [Styles.running]: isRunning,
                      [Styles.completed]: !progress.isRunning && progress.percentComplete === 100,
                    })}
                    key={progress.title}
                  >
                    <Heading level={5}>
                      {progress.title}
                      {isRunning && (
                        <>
                          <span>... </span>
                          <span className={Styles.progressPercentage}>{progress.percentComplete}%</span>
                        </>
                      )}
                    </Heading>
                  </div>
                )
              })}
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}
